module.exports = __webpack_public_path__ + "static/media/defizap.73e2ed11.svg";